export class RegisterRsvpDTO {
  firstName: string = "";
  lastName: string = "";
  email: string = "";
  profilePicUrl?: string | { fileDownloadUri: string } | null;
  profilePicId!: number;
  id: any;
}

export class GetDataRsvpDTO {
  id: any;
  firstName: string = "";
  lastName: string = "";
  email: string = "";
  profilePicUrl: string = "";
  profilePicId!: number;
}
